import { b64toBlob } from './convert-b64-blob';

export const openFilePreview = (file: string) => {
  const fileBlob = b64toBlob(file, 'application/pdf');
  const fileURL = URL.createObjectURL(fileBlob);
  openFileOnWindow(fileURL);
};

export const openFileOnWindow = (fileURL: string) => {
  window.open(fileURL, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=900,left=0,width=0,height=600');
};
